<template>
  <v-form>
    <v-container v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="150" :width="8" color="green"></v-progress-circular>
      </div>
    </v-container>
    <v-container v-else>
      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="商品データファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            v-validate="'required'"
            data-vv-name="fileName"
            :error-messages="errors.collect('fileName')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv, .xls"
            @change="onFileChange($event)"
          />          
          <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 sm6>
          <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
        </v-flex>
      </v-layout>
      <div style="height: 20px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>Home
          </v-btn>
        </v-flex>
        <v-flex xs12 sm3>
          <v-btn block color="primary" dark @click="downloadItemsCsv()">
            <v-icon dark left>get_app</v-icon>データダウンロード
          </v-btn>
        </v-flex>
      </v-layout>
      <br />

      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <tr 
            v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted) || '1' === props.item.displayOnScreen "
            v-bind:class="{'deleted-class-name': props.item.isDeleted == '1' ? true : false}"
          >
            <td class="text-xs-left">{{ props.item.janCode }}</td>
            <td class="text-xs-left">{{ props.item.itemName }}</td>
            <td class="text-xs-left">{{ props.item.prdCode }}</td>
            <td class="text-xs-right">{{ props.item.prdQuantity }}</td>
            <td class="text-xs-right">{{ props.item.prdWidth }}</td>
            <td class="text-xs-right">{{ props.item.prdDepth }}</td>
            
            <td class="text-xs-right">{{ props.item.prdHeight }}</td>
            <td class="text-xs-right">{{ props.item.caseWidth }}</td>
            <td class="text-xs-right">{{ props.item.caseDepth }}</td>
            <td class="text-xs-right">{{ props.item.caseHeight }}</td>
            <td class="text-xs-right">{{ props.item.caseWeight }}</td>
          </tr>
        </template>
      </v-data-table>      
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.getAllItems()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.itemCategoryId < b.itemCategoryId) {
          return -1
        } else if (a.itemCategoryId > b.itemCategoryId) {
          return 1
        }
        if (a.itemName < b.itemName) {
          return -1
        } else if (a.itemName > b.itemName) {
          return 1
        }
        return 0
      })
      return items
    },
    getAllItems() {
      console.log('refresh items')
      let thisObj = this
      // 初期表示時の
      thisObj.loading = true

      ServerApiCallService.tempItems()
        .then(response => {
          thisObj.items = response.data.items
          // 初期表示時の
          thisObj.loading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true
      ServerApiCallService.sendItemsTempFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading1 = false
          // 초기화면
          this.getAllItems();
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },
    downloadItemsCsv() {
      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/items-temp-download', {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '商品一覧.csv'
          link.click()
        })
    }
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      dispDeleted: 'info',
      items: [],
      fileName: '',
      fileFormat: 'SHIFT-JIS',
      headers: [
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品コード2',
          align: 'left',
          value: 'prdCode',
          width: '30px',
          sortable: false
        },
        {
          text: '入数',
          align: 'center',
          value: 'prdQuantity',
          width: '20px',
          sortable: false
        },
        {
          text: '幅(商品)',
          align: 'center',
          value: 'prdWidth',
          width: '20px',
          sortable: false
        },
        {
          text: '奥行(商品)',
          align: 'center',
          value: 'prdDepth',
          width: '20px',
          sortable: false
        },
        {
          text: '高さ(商品)',
          align: 'center',
          value: 'prdHeight',
          width: '20px',
          sortable: false
        },
        {
          text: '幅(ケース)',
          align: 'center',
          value: 'caseWidth',
          width: '20px',
          sortable: false
        },
        {
          text: '奥行(ケース)',
          align: 'center',
          value: 'caseDepth',
          width: '20px',
          sortable: false
        },
        {
          text: '高さ(ケース)',
          align: 'center',
          value: 'caseHeight',
          width: '20px',
          sortable: false
        },
        {
          text: '重量(ケース)',
          align: 'center',
          value: 'caseWeight',
          width: '20px',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}

.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.invisible-class-name {
  background-color: #b3e460;
}
</style>
